'use client';

import { FaFacebook, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import { getExternalLinkRel } from '@/lib/utils';

interface SocialMediaShareProps {
  blogUrl: string;
  blogTitle: string;
}

const SocialMediaShare: React.FC<SocialMediaShareProps> = ({ blogUrl, blogTitle }) => {
  const slugify = (text: string) =>
    text
      .toString()
      .replace(/\s*\([^)]*\)\s*/g, '')
      .toLowerCase()
      .trim()
      .replace(/[:\/"'`\[\]{}\?!@#$%^&*+,]+/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  let safeUrl = blogUrl;
  if (!/^https?:\/\//i.test(blogUrl)) {
    try {
      const parsed = new URL(blogUrl, typeof window !== 'undefined' ? window.location.origin : '');
      if (parsed.pathname && (parsed.pathname.includes(' ') || /%20/.test(parsed.pathname))) {
        const slug = slugify(blogTitle || parsed.pathname.split('/').pop() || '');
        parsed.pathname = `/blog/${slug}`;
      }
      safeUrl = parsed.toString();
    } catch {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const slug = slugify(blogTitle || blogUrl);
      const pathname = blogUrl.startsWith('/') ? blogUrl : `/blog/${slug}`;
      safeUrl = origin ? `${origin}${pathname}` : pathname;
    }
  }

  const whatsappShareHref = `https://wa.me/?text=${encodeURIComponent(`${blogTitle} - ${safeUrl}`)}`;
  const twitterShareHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(blogTitle)}&url=${encodeURIComponent(safeUrl)}`;
  const facebookShareHref = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(safeUrl)}`;

  return (
    <div className="flex items-center gap-3">
      <a
        href={whatsappShareHref}
        target="_blank"
        rel={getExternalLinkRel(whatsappShareHref, 'noopener noreferrer')}
        aria-label="Share on WhatsApp"
      >
        <FaWhatsapp className="text-xl" />
      </a>
      <a
        href={twitterShareHref}
        target="_blank"
        rel={getExternalLinkRel(twitterShareHref, 'noopener noreferrer')}
        aria-label="Share on Twitter"
      >
        <FaTwitter className="text-xl" />
      </a>
      <a
        href={facebookShareHref}
        target="_blank"
        rel={getExternalLinkRel(facebookShareHref, 'noopener noreferrer')}
        aria-label="Share on Facebook"
      >
        <FaFacebook className="text-xl" />
      </a>
    </div>
  );
};

export default SocialMediaShare;
